import { useState } from "react";

const cats = ["全部", "塌房现场", "实锤", "脱粉瞬间", "口碑崩盘", "辟谣"];

const feeds = [
  { cat: "塌房现场", time: "09:20", tag: "进展", title: "贾大嘴 合作品牌已由 3 家增至 5 家官宣切割，解约名单持续更新" },
  { cat: "实锤", time: "08:45", tag: "证据", title: "苏念 抄袭比对视频累计播放破 8000 万，原博晒出律师函草稿" },
  { cat: "脱粉瞬间", time: "08:02", tag: "回踩", title: "顾言 超话签到人数较昨日下降 37%，粉丝站「停止应援」联合声明发布" },
  { cat: "口碑崩盘", time: "07:30", tag: "预警", title: "白允 代言品牌连夜下架宣传物料，评论区被「假唱」刷屏" },
  { cat: "辟谣", time: "06:55", tag: "澄清", title: "某经纪公司就「行程冲突」传闻辟谣，网友质疑与昨日爆料时间线矛盾" },
  { cat: "实锤", time: "昨天", tag: "证据", title: "池野 与经纪人越界画面逐帧分析出炉，三处牵手依偎细节被指出" },
  { cat: "塌房现场", time: "昨天", tag: "直播", title: "陆衍 综艺录制现场录音片段流出，台上台下两副面孔引发热议" },
  { cat: "口碑崩盘", time: "前天", tag: "考古", title: "导演 程墨 三年前饭局录制备份被公开，多观点与今日人设正面冲突" },
];

export default function Feed() {
  const [active, setActive] = useState("全部");
  const shown = active === "全部" ? feeds : feeds.filter((f) => f.cat === active);

  return (
    <section id="feed" className="w-full bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid gap-6 lg:grid-cols-12 lg:gap-8">
          {/* 左：快讯流主体 */}
          <div className="lg:col-span-8">
            <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <p className="mb-1.5 text-xs font-bold uppercase tracking-[0.2em] text-secondary-600">
                  Live Feed · 现场快讯流
                </p>
                <h3 className="font-display text-2xl font-black text-foreground-950 md:text-3xl">
                  每一条都在路上
                </h3>
              </div>
              <div className="flex items-center gap-1.5 text-xs font-semibold text-foreground-500">
                <span className="gk-pulse inline-block h-2 w-2 rounded-full bg-primary-500"></span>
                信号正常 · 持续推送
              </div>
            </div>

            {/* 类别胶囊（可点击筛选） */}
            <div className="mb-4 flex flex-wrap gap-2">
              {cats.map((c) => (
                <button
                  key={c}
                  type="button"
                  onClick={() => setActive(c)}
                  className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors ${
                    active === c
                      ? "bg-foreground-950 text-background-50"
                      : "bg-background-100 text-foreground-600 hover:bg-background-200"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>

            {/* 快讯列表 */}
            <div className="relative">
              <div className="absolute bottom-1 left-[5px] top-1 w-px bg-background-200"></div>
              <ul className="space-y-2.5">
                {shown.map((f) => (
                  <li key={f.title}>
                    <a
                      href="#feed"
                      className="group relative flex cursor-pointer items-start gap-3.5 rounded-2xl border border-transparent px-2 py-2.5 transition-colors hover:border-background-200 hover:bg-background-100/60 md:px-3"
                    >
                      <span className="relative z-10 mt-1 h-2.5 w-2.5 shrink-0 rounded-full border-2 border-background-50 bg-secondary-400 ring-1 ring-secondary-300"></span>
                      <span className="mt-0.5 w-12 shrink-0 text-xs font-semibold text-foreground-400">
                        {f.time}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block text-[14px] font-semibold leading-snug text-foreground-800 transition-colors group-hover:text-primary-700 md:text-[15px]">
                          {f.title}
                        </span>
                      </span>
                      <span
                        className={`mt-0.5 hidden shrink-0 rounded-full px-2 py-0.5 text-[11px] font-bold sm:inline-block ${
                          f.cat === "辟谣"
                            ? "bg-secondary-100 text-secondary-700"
                            : "bg-accent-100 text-accent-800"
                        }`}
                      >
                        {f.tag}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* 右：编辑部随记 */}
          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-24 overflow-hidden rounded-2xl border border-background-200/80 bg-background-100/60">
              <div className="border-b border-background-200 px-5 py-3.5">
                <h4 className="flex items-center gap-2 font-display text-base font-bold text-foreground-950">
                  <i className="ri-edit-2-fill text-primary-500"></i>
                  编辑部随记
                </h4>
              </div>
              <div className="space-y-4 px-5 py-4">
                <p className="text-sm leading-relaxed text-foreground-700">
                  今天最微妙的一刻，是<b className="text-foreground-950">顾言</b>那条「只是有点累」的告别。
                  我们翻了他去年说「粉丝是我家人」的同款机场视频——两帧放一起，谁在变，一目了然。
                </p>
                <p className="text-sm leading-relaxed text-foreground-700">
                  别急着站队。<b className="text-foreground-950">实锤看证据，塌房看时间线</b>，
                  我们只把 24 小时内出现、又能核到的记录，一帧帧摆给你看。
                </p>
                <div className="flex items-center gap-2.5 border-t border-background-200 pt-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                    <i className="ri-leaf-line text-lg"></i>
                  </span>
                  <div className="leading-tight">
                    <p className="text-xs font-bold text-foreground-900">呱呱编辑部 · 值班瓜农</p>
                    <p className="mt-0.5 text-[11px] text-foreground-500">今日 18:00 前已复核 12 条</p>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}